import useChatMemoStore from "@/stores/chat-memo";
import AddMemoIcon from "../ui/icons/AddMemoIcon";
import { Text } from "../ui/text";
import { useCreateAiChatMemoMutation } from "@/hooks/services/mutations/chat-memo/use-create-ai-chat-memo-mutation";
import { useQueryClient } from "@tanstack/react-query";
import { instance } from "@/apis";

const AddMessageChatMemoButton = ({
  chatId,
  chatHistoryId,
  messageIndex,
}: {
  chatId: string;
  chatHistoryId?: string;
  messageIndex: number;
}) => {
  const queryClient = useQueryClient();
  const { mutateAsync: createMemo } = useCreateAiChatMemoMutation();
  const setIsLoading = useChatMemoStore((state) => state.setIsLoading);
  const isLoading = useChatMemoStore((state) => state.isLoading);
  const openChatMemo = useChatMemoStore((state) => state.openChatMemo);
  const setSelectedMemoId = useChatMemoStore((state) => state.setSelectedMemoId);
  const setCurrentView = useChatMemoStore((state) => state.setCurrentView);
  const getHistoryId = async (): Promise<string | null> => {
    if (chatHistoryId) return chatHistoryId;
    const res = await instance.get(`/api/df/user/chat/${chatId}`);
    const messages: { id: string; messageType: string }[] = res?.data?.data ?? [];
    const matched = messages[messageIndex];
    return matched?.id ?? null;
  };
  

  const handleMemoClick = async () => {
    setIsLoading(true);
    try {
      const getchatHistoryId = await getHistoryId();
      if (!getchatHistoryId) return;
      const res = await createMemo({ chatId, chatHistoryId: getchatHistoryId });
      if (res.data.code.startsWith("S")) {
        setCurrentView("detail");
        setSelectedMemoId(res.data.data.id);
        queryClient.invalidateQueries({ queryKey: ["chat-memos", chatId] });
        openChatMemo();
      }
    } catch (error) {
      console.error("create chat memo error", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <button
      onClick={handleMemoClick}
      disabled={isLoading}
      className="flex items-center"
    >
      <div className="w-[40px] h-[40px] flex items-center justify-center">
        <AddMemoIcon />
      </div>
      <Text variant="label-lg">Memo</Text>
    </button>
  );
};

export default AddMessageChatMemoButton;
